import { render, staticRenderFns } from "./qua.vue?vue&type=template&id=22201cf2&scoped=true&"
import script from "./qua.vue?vue&type=script&lang=js&"
export * from "./qua.vue?vue&type=script&lang=js&"
import style0 from "./qua.vue?vue&type=style&index=0&id=22201cf2&prod&scoped=true&lang=less&"
import style1 from "./qua.vue?vue&type=style&index=1&id=22201cf2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22201cf2",
  null
  
)

export default component.exports